import { useContext } from "react";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";

const PvSLD = ({x,y,id,index, selectHandler}) => {
    const {
    CBAssetList,
    padNumberFormat,
    PVDetails,
  } = useContext(DesignAssetContext);
    return (
        <g id={id}>
        <svg
          x = {x}
          y = {y}
          width="195px"
          height="130px"
          viewBox="0 0 10 149"
          onClick={selectHandler}
        >
          <title>
            {PVDetails?.[`pvset${index}Data`]?.[0] ? PVDetails?.[`pvset${index}Data`][0].groupName : ""}

          </title>
          <g
            id="Design"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Design/Assets-_-00"
              transform="translate(-1036.000000, -372.000000)"
            >
              <g
                id="SLD/PV/Uniline/Multiple_Done"
                transform="translate(1036.000000, 372.000000)"
              >
                <circle
                  id="Oval"
                  stroke="#42B4E6"
                  strokeWidth="3"
                  cx="48"
                  cy="56"
                  r="55"
                  style={CBAssetList?.[index]?.uiData.selected ? {} : { display: "none" }}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="rgba(0, 135, 205, 0.2)"
                ></circle>

                <circle
                  id="Oval"
                  stroke={CBAssetList?.[index]?.uiData.configured ? "var(--se-sld-circline)" : "#E47F00"}
                  strokeWidth="3"
                  fill="var(--se-background-alternative)"
                  fillRule="evenodd"
                  cx="57"
                  cy="59"
                  r="43.5"
                ></circle>

                <line
                  x1="48.5"
                  y1="102.287109"
                  x2="48.5"
                  y2="144"
                  id="Line-2"
                  stroke={CBAssetList?.[index]?.uiData.configured ? "var(--se-sld-circline)" : "#E47F00"}
                  strokeWidth="3"
                  strokeLinejoin="round"
                ></line>
                <circle
                  id="Oval"
                  stroke={CBAssetList?.[index]?.uiData.configured ? "var(--se-sld-circline)" : "#E47F00"}
                  strokeWidth="3"
                  fill="var(--se-background-alternative)"
                  fillRule="evenodd"
                  cx="48"
                  cy="55"
                  r="46.5"
                ></circle>

                <circle
                  id="Oval"
                  stroke={CBAssetList?.[index]?.uiData.configured ? "var(--se-sld-circline)" : "#E47F00"}
                  strokeWidth="3"
                  fill="var(--se-background-alternative)"
                  fillRule="evenodd"
                  cx="48"
                  cy="55"
                  r="46.5"
                ></circle>

                <g
                  id="999🔒Atoms/Notifications/Done"
                  transform="translate(66.000000, 2.000000)"
                >
                  <g
                    id="999🔒Atoms/Background/Round"
                    strokeWidth="1"
                    fillRule="evenodd"
                    fill={CBAssetList?.[index]?.uiData.configured ? "var(--se-sld-circline)" : "#E47F00"}
                    stroke="var(--se-background-alternative)"
                  >
                    <circle
                      id="Oval"
                      strokeWidth="2.66666667"
                      cx="16"
                      cy="16"
                      r="18"
                    ></circle>
                  </g>

                  <text
                    id="3"
                    fontFamily="Nunito-Regular, Nunito"
                    fontSize="24"
                    fontWeight="normal"
                    fill="var(--se-background-alternative)"
                  >
                    <tspan x="2" y="24">
                      {padNumberFormat(CBAssetList?.[index]?.uiData.count)}
                    </tspan>
                  </text>
                </g>
                <text
                  id="solar_panel1"
                  fontFamily="se-icon"
                  fontSize="56"
                  fontWeight="normal"
                  fill="var(--se-sld-circline)"
                >
                  <tspan x="20" y="69">
                    solar_panel1
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </svg>
      </g>
    );
};
export default PvSLD;